import classNames from 'classnames';

export interface TextInputProps {
  ariaLabel?: string;
  value?: string;
  placeholder?: string;
  disabled?: boolean;
  autoComplete?: 'on' | 'none';
  onChange?: (newValue: string) => void;
  onKeyDown?: (event: React.KeyboardEvent) => void;
  onBlur?: (event: React.FocusEvent) => void;
  styles?: string;
  testId?: string;
  name?: string;
  id?: string;
  required?: boolean;
}

export const TextInput = ({
  testId,
  placeholder,
  value,
  disabled,
  onChange,
  onBlur,
  onKeyDown,
  ariaLabel,
  styles,
  autoComplete,
  name,
  id,
  required = false,
}: TextInputProps) => {
  let isSafariBrowser: boolean;
  if (typeof navigator !== 'undefined') {
    isSafariBrowser = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
  }
  return (
    <input
      placeholder={placeholder}
      data-testid={testId ?? 'textinput-input'}
      disabled={disabled}
      value={value}
      onChange={event => onChange?.(event.target.value)}
      onKeyDown={event => onKeyDown?.(event)}
      onBlur={event => onBlur?.(event)}
      className={classNames(
        'text-2xl',
        'w-full',
        'px-6',
        'py-2',
        'appearance-none',
        'focus:outline-none',
        'block',
        'border',
        'border-gray-200',
        'disabled:bg-gray-200',
        isSafariBrowser ? 'disabled:text-gray-800' : ' disabled:text-gray-400',
        'placeholder-gray-300',
        styles
      )}
      type="text"
      aria-label={ariaLabel}
      autoComplete={autoComplete}
      name={name}
      id={id}
      required={required}
    />
  );
};
